export default "__VITE_ASSET__SDvcFq$g__"